'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _coverLots = require('./remote/coverLots');

var CoverLots = {
    fetchCoverLots: function fetchCoverLots(params) {
        return _coverLots.CoverLotsRemote.fetchCoverLots(params);
    }
};

exports.default = CoverLots;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/coverLots.js
// module id = 8kzA
// module chunks = 46